import { Provider } from '@angular/core';
import {
  CONTRACT_ACTIVITIES_STORE,
  resolveContractActivitiesStoreMode
} from './contract-activities-store.interface';
import { ContractActivitiesMockStore } from './contract-activities-mock-store.service';
import { ContractActivitiesFirestoreStore } from './contract-activities-firestore-store.service';

export function provideContractActivitiesStore(): Provider[] {
  return [
    ContractActivitiesMockStore,
    ContractActivitiesFirestoreStore,
    {
      provide: CONTRACT_ACTIVITIES_STORE,
      useFactory: (mock: ContractActivitiesMockStore, firestore: ContractActivitiesFirestoreStore) =>
        resolveContractActivitiesStoreMode() === 'mock' ? mock : firestore,
      deps: [ContractActivitiesMockStore, ContractActivitiesFirestoreStore]
    }
  ];
}
